import { toastifyType } from "../../../constant"
import { addTost } from "../toastAction"
import axios from "axios"
import { environment } from "../../../config/environment"

export const verifyEmail = (token, navigate, setIsVerified) => async (dispatch) => {
    try {
        setIsVerified(true)
        const response = await axios.post(`${environment.SERVER_URL}/api/auth/verify-email?token=${token}`)
        if (response?.data?.success) {
            setTimeout(() => {
                navigate('/login', { replace: true })
            }, 2000)
        }
        dispatch(addTost({ type: toastifyType.SHOW_SUCCESS_MESSAGE, message: response?.data?.message }))
        setIsVerified(false)
        return response?.data
    } catch (error) {
        console.log(error)
        const axiosError = error;
        const errorMessage = axiosError.response?.data?.errors || 'Email verification failed.';
        setIsVerified(false)
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: errorMessage }))
    }
}